// Navigation - main/top
export const navigationHomeSelector = ({ navigationData }) =>
  navigationData.home;
export const navigationMessagesSelector = ({ navigationData }) =>
  navigationData.messages;
export const navigationContactsSelector = ({ navigationData }) =>
  navigationData.contacts;
export const navigationJobsSelector = ({ navigationData }) =>
  navigationData.jobs;
export const navigationMenuSelector = ({ navigationData }) =>
  navigationData.menu;

// Navigation - secondary/other
export const navigationCampusSelector = ({ navigationData }) =>
  navigationData.campus;
export const navigationContentSelector = ({ navigationData }) =>
  navigationData.content;
export const navigationEventsSelector = ({ navigationData }) =>
  navigationData.events;
export const navigationGroupsSelector = ({ navigationData }) =>
  navigationData.groups;
export const navigationCompaniesSelector = ({ navigationData }) =>
  navigationData.companies;
export const navigationServicesSelector = ({ navigationData }) =>
  navigationData.services;
export const navigationPremiumSelector = ({ navigationData }) =>
  navigationData.premium;
export const navigationPremiumUpsellSelector = ({ navigationData }) =>
  navigationData.premiumUpsell;
export const navigationProJobsSelector = ({ navigationData }) =>
  navigationData.proJobs;
export const navigationProBusinessSelector = ({ navigationData }) =>
  navigationData.proBusiness;
export const navigationSettingsPersonalSelector = ({ navigationData }) =>
  navigationData.settingsPersonal;
export const navigationLogoutPersonalSelector = ({ navigationData }) =>
  navigationData.logoutPersonal;
export const navigationHelpFooterSelector = ({ navigationData }) =>
  navigationData.helpFooter;
export const navigationImprintSelector = ({ navigationData }) =>
  navigationData.imprint;
export const navigationTAndCSelector = ({ navigationData }) =>
  navigationData.tAndC;
export const navigationPrivacyAtXingSelector = ({ navigationData }) =>
  navigationData.privacyAtXing;
export const navigationPrivacyPolicySelector = ({ navigationData }) =>
  navigationData.privacyPolicy;
export const navigationBusinessSelector = ({ navigationData }) =>
  navigationData.business;

// About Links
export const helpFooterSelector = ({ navigationData }) =>
  navigationData.helpFooter;
export const aboutFooterSelector = ({ navigationData }) =>
  navigationData.aboutFooter;
export const careersFooterSelector = ({ navigationData }) =>
  navigationData.careersFooter;
export const investorRelationsFooterSelector = ({ navigationData }) =>
  navigationData.investorRelationsFooter;
export const pressFooterSelector = ({ navigationData }) =>
  navigationData.pressFooter;
export const xingCommunityFooterSelector = ({ navigationData }) =>
  navigationData.xingCommunityFooter;
export const newWorkExperienceFooterSelector = ({ navigationData }) =>
  navigationData.newWorkExperienceFooter;
export const blogFooterSelector = ({ navigationData }) =>
  navigationData.blogFooter;
export const devBlogFooterSelector = ({ navigationData }) =>
  navigationData.devBlogFooter;
export const developersFooterSelector = ({ navigationData }) =>
  navigationData.developersFooter;
export const peopleDirectoryFooterSelector = ({ navigationData }) =>
  navigationData.peopleDirectoryFooter;

// Apps Links
export const appsSelector = ({ navigationData }) => navigationData.apps;
export const loginWithXingSelector = ({ navigationData }) =>
  navigationData.loginWithXing;
export const shareButtonSelector = ({ navigationData }) =>
  navigationData.shareButton;
export const downloadsSelector = ({ navigationData }) =>
  navigationData.downloads;

// Offer Links
export const premiumOfferSelector = ({ navigationData }) =>
  navigationData.premiumOffer;
export const proJobsOfferSelector = ({ navigationData }) =>
  navigationData.proJobsOffer;
export const proBusinessOfferSelector = ({ navigationData }) =>
  navigationData.proBusinessOffer;
export const benefitsPlusOfferSelector = ({ navigationData }) =>
  navigationData.benefitsPlusOffer;
export const executivesOfferSelector = ({ navigationData }) =>
  navigationData.executivesOffer;
export const eRecruitingOfferSelector = ({ navigationData }) =>
  navigationData.eRecruitingOffer;
export const advertisementOfferSelector = ({ navigationData }) =>
  navigationData.advertisementOffer;
export const marketingSolutionsOfferSelector = ({ navigationData }) =>
  navigationData.marketingSolutionsOffer;
export const halloFreelancerOfferSelector = ({ navigationData }) =>
  navigationData.halloFreelancerOffer;
export const mobileOfferSelector = ({ navigationData }) =>
  navigationData.mobileOffer;
export const premiumOfferPartnersSelector = ({ navigationData }) =>
  navigationData.premiumOfferPartners;
export const xingEventsOfferSelector = ({ navigationData }) =>
  navigationData.xingEventsOffer;
export const salaryCheckOfferSelector = ({ navigationData }) =>
  navigationData.salaryCheckOffer;
export const salaryCheckMatchOfferSelector = ({ navigationData }) =>
  navigationData.salaryCheckMatchOffer;
export const curriculumVitaeEditorSelector = ({ navigationData }) =>
  navigationData.curriculumVitaeEditor;
export const coverLetterEditorSelector = ({ navigationData }) =>
  navigationData.coverLetterEditor;
export const jobApplicationTipsSelector = ({ navigationData }) =>
  navigationData.jobApplicationTips;
export const kununuOfferSelector = ({ navigationData }) =>
  navigationData.kununuOffer;

// Site Sections Links
export const jobsFooterSelector = ({ navigationData }) =>
  navigationData.jobsFooter;
export const eventsFooterSelector = ({ navigationData }) =>
  navigationData.eventsFooter;
export const newsFooterSelector = ({ navigationData }) =>
  navigationData.newsFooter;
export const groupsFooterSelector = ({ navigationData }) =>
  navigationData.groupsFooter;
export const companiesFooterSelector = ({ navigationData }) =>
  navigationData.companiesFooter;
export const campusFooterSelector = ({ navigationData }) =>
  navigationData.campusFooter;
export const coachesFooterSelector = ({ navigationData }) =>
  navigationData.coachesFooter;

// Settings Dropdown Links
export const premiumUpsellPersonalSelector = ({ navigationData }) =>
  navigationData.premiumUpsellPersonal;
export const proJobsPersonalSelector = ({ navigationData }) =>
  navigationData.proJobsPersonal;
export const proBusinessMemberPersonalSelector = ({ navigationData }) =>
  navigationData.proBusinessMemberPersonal;
export const benefitsPersonalSelector = ({ navigationData }) =>
  navigationData.benefitsPersonal;
export const proJobsMemberPersonalSelector = ({ navigationData }) =>
  navigationData.proJobsMemberPersonal;
export const coachProfilePersonalSelector = ({ navigationData }) =>
  navigationData.coachProfilePersonal;
export const xtmPersonalSelector = ({ navigationData }) =>
  navigationData.xtmPersonal;
export const seatManagerAdminPersonalSelector = ({ navigationData }) =>
  navigationData.seatManagerAdminPersonal;
export const jobsPosterPersonalSelector = ({ navigationData }) =>
  navigationData.jobsPosterPersonal;
export const brandPagePersonalSelector = ({ navigationData }) =>
  navigationData.brandPagePersonal;
export const admasterUserPersonalSelector = ({ navigationData }) =>
  navigationData.admasterUserPersonal;
export const brandManagerEditorSelector = ({ navigationData }) =>
  navigationData.brandManagerEditor;
export const invoicesPersonalSelector = ({ navigationData }) =>
  navigationData.invoicesPersonal;

export default {
  navigationHomeSelector,
  navigationMessagesSelector,
  navigationContactsSelector,
  navigationJobsSelector,
  navigationMenuSelector,
  navigationCampusSelector,
  navigationContentSelector,
  navigationEventsSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  navigationServicesSelector,
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
  navigationSettingsPersonalSelector,
  navigationLogoutPersonalSelector,
  navigationHelpFooterSelector,
  navigationImprintSelector,
  navigationTAndCSelector,
  navigationPrivacyAtXingSelector,
  navigationPrivacyPolicySelector,
  navigationBusinessSelector,
  helpFooterSelector,
  aboutFooterSelector,
  careersFooterSelector,
  investorRelationsFooterSelector,
  pressFooterSelector,
  xingCommunityFooterSelector,
  newWorkExperienceFooterSelector,
  blogFooterSelector,
  devBlogFooterSelector,
  developersFooterSelector,
  peopleDirectoryFooterSelector,
  appsSelector,
  loginWithXingSelector,
  shareButtonSelector,
  downloadsSelector,
  premiumOfferSelector,
  proJobsOfferSelector,
  proBusinessOfferSelector,
  benefitsPlusOfferSelector,
  executivesOfferSelector,
  eRecruitingOfferSelector,
  advertisementOfferSelector,
  marketingSolutionsOfferSelector,
  halloFreelancerOfferSelector,
  mobileOfferSelector,
  premiumOfferPartnersSelector,
  xingEventsOfferSelector,
  salaryCheckOfferSelector,
  curriculumVitaeEditorSelector,
  coverLetterEditorSelector,
  jobApplicationTipsSelector,
  kununuOfferSelector,
  jobsFooterSelector,
  eventsFooterSelector,
  newsFooterSelector,
  groupsFooterSelector,
  companiesFooterSelector,
  campusFooterSelector,
  coachesFooterSelector,
};
